<script lang="ts">
import { getContext } from 'svelte'
import { fade } from 'svelte/transition'

import DateTime from '@/components/date/DateTime.svelte'
import TimeRelative from '@/components/date/TimeRelative.svelte'
import { contentListItemKey, lastMessageId, type WritableMessageContext } from '@/modules/messages'
import { isRelativeTimeFormatSupported } from '@/utils/date'

type Props = {
	id: string
	createdAt: string
	isLastAttachment?: boolean
}

let { id, createdAt, isLastAttachment = false }: Props = $props()

let isLastMessage: boolean = $derived(id === $lastMessageId)

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let {
	group: { align },
	attachmentsContext,
} = $derived($context)
let hasAttachments = $derived(attachmentsContext.length > 0)
</script>

{#if isLastMessage && (!hasAttachments || isLastAttachment)}
	<div
		in:fade={{ delay: 800 }}
		class={['absolute -bottom-4.5 w-max text-xs text-gray-400', align.isLeft && 'left-2', align.isRight && 'right-2']}
	>
		{#if isRelativeTimeFormatSupported()}
			<TimeRelative date={createdAt} />
		{:else}
			<DateTime date={createdAt} />
		{/if}
	</div>
{/if}
